import { IMeta } from "store/user/user.types";

export const getSectionKeyFromLink = (link: string): string => {
  const pathParts = link.split("/").filter(part => part.length > 0);
  return pathParts[ 0 ] || "";
};

export const getMetaCount = (meta: IMeta | null, sectionKey: string, fieldKey?: string): number => {
  if (!meta?.[ sectionKey ]) return 0;
  
  const sectionData = meta[ sectionKey ];

  if (fieldKey && sectionData && typeof sectionData === "object") {
    const fieldValue = sectionData[ fieldKey ];
    return typeof fieldValue === "number" ? fieldValue : 0;
  }
  
  return 0;
};

